import { render, staticRenderFns } from "./taxTransPropertyList.vue?vue&type=template&id=1d22edaf&scoped=true&"
import script from "./taxTransPropertyList.vue?vue&type=script&lang=js&"
export * from "./taxTransPropertyList.vue?vue&type=script&lang=js&"
import style0 from "./taxTransPropertyList.vue?vue&type=style&index=0&id=1d22edaf&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d22edaf",
  null
  
)

export default component.exports